import { SidebarContent } from './SidebarContent'
import type { CompanySidebarHeader, SidebarTabConfig } from './index'

interface CompanySidebarNewProps {
  chainProxyId: number
  header: CompanySidebarHeader
  tabs: SidebarTabConfig[]
  doorId?: number
  address?: string
  phone?: string
}

/**
 * New sidebar for new navigation - flex-based layout without sticky.
 * @see TODO in NewCompanyPage/index.tsx for cleanup steps when old nav is removed.
 */
export function CompanySidebarNew(props: CompanySidebarNewProps) {
  return (
    <div className="bg-white rounded-lg border border-gray-200 shadow-sm w-[360px] flex-shrink-0 flex flex-col mb-4">
      <div className="p-[20px] w-[360px] flex flex-col relative flex-1 min-h-0">
        <SidebarContent {...props} />
      </div>
    </div>
  )
}
